module.exports = __webpack_public_path__ + "img/sbzc_03.433fa807.jpg";